module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_10_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_10_before.jpg
// module id = 1154
// module chunks = 0